<template>
  <div class="BigDataRoll" ref="rollEl" @scroll="countAntiShake">
    <div class="BigDataRoll-all" :style="{ 'height': sumHeight }">
      <div class="BigDataRoll-mian"
        :style="{
          'transform': 'translateY(' + topHeight + ')',
        }"
      >
        <slot v-bind:list="data"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    },
    // 单行高(px)
    rowHeight: {
      type: Number,
      default: 50,
    },
    // 渲染数量
    showNum: {
      type: Number,
      default: 100,
    },
  },
  data () {
    return {
      data: [],
      sumHeight: 0,
      topHeight: 0,

      antiShakeTimeOj: null,
    };
  },
  watch: {
    list () {
      this.init()
    },
  },
  computed: {
  },
  created () {
  },
  mounted () {
    window.addEventListener('resize', this.countAntiShake, false);
  },
  methods: {
    init () {
      let total = this.list.length,
          showNum = this.showNum,
          rowHeight = this.rowHeight

      this.sumHeight = this.pxToRem((total + 1) * rowHeight) + 'rem'
      this.topHeight = 0

      let showData = []
      this.list.forEach((item, index)=>{
        if (index < showNum) {
          showData.push(item)
        }
      })
      this.data = showData

      // console.log(total, this.sumHeight)
    },
    
    countAntiShake () {
      clearTimeout(this.antiShakeTimeOj)
      this.antiShakeTimeOj = setTimeout(() => {
        this.countBoxData()
      }, 100);
    },
    countBoxData () {
      let total = this.list.length,
          rowHeight = this.rowHeight,
          showNum = this.showNum,
          topIndex = 0,
          offsetHeight = this.$refs.rollEl.offsetHeight,
          scrollHeight = this.$refs.rollEl.scrollHeight,
          scrollTop = this.$refs.rollEl.scrollTop

      // console.log(offsetHeight, scrollHeight, scrollTop)

      if (total <= showNum) {
        this.topHeight = 0
        return
      }

      let proportion = 1920 / window.innerWidth
      let centerPx = scrollTop + (offsetHeight / 2) // 显示区域中心的x
      centerPx = centerPx * proportion
      let centerItemIndex = +(centerPx / rowHeight).toFixed(0) // 中心区域的数据的index
      // console.log('centerIndex: ' + centerItemIndex)

      let topNum = +((showNum - 1) / 2).toFixed(0) // 中心那条上面显示的条数
      topNum = centerItemIndex >= topNum ? topNum : centerItemIndex
      topIndex = centerItemIndex - topNum
      
      let showData = []
      this.list.forEach((item, index)=>{
        if (index >= topIndex && index < (topIndex + showNum)) {
          showData.push(item)
        }
      })

      this.data = showData
      // console.log(showData)
      this.topHeight = this.pxToRem(topIndex * rowHeight) + 'rem'
    },
    pxToRem (pxV) {
      return +(pxV / 100).toFixed(3)
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.countAntiShake, false);
  },
};
</script>

<style lang='less' scoped>
.BigDataRoll {
  overflow: auto;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #4cb6f3
  }
  &::-webkit-scrollbar-track {
    width: 8px;
    border-radius: 4px;
    background: transparent;
    background-color: #4cb6f330;
  }
  .BigDataRoll-all {
    overflow: hidden;
  }
  .BigDataRoll-mian {
    margin: 0;
    padding: 0;
  }
}
</style>